<template>
  <v-badge
    bordered
    overlap
    icon="fas fa-ban"
    :value="question.invalidated"
    color="bg-gray-400 text-black "
    class="w-100"
  >
    <v-card
      rounded="sm"
      outlined
      class="w-100 pointer-on-hover"
      :class="{
        'success_item' : answerIsCorrect,
        'bg-theme' : !answerIsCorrect,
      }"
      @click="$emit('click')"
    >
      <div
        class="text-white text-center marker-number d-flex align-center justify-center"
      >
        {{ question.key + 1 }}
      </div>
      <div class="bg-white text-uppercase text-center marker-answer d-flex align-center justify-center">
        {{ question.user_answer }}
      </div>
    </v-card>
  </v-badge>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MarkerComponentInput',
  props: {
    question: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  computed:{
    ...mapGetters(['authUser']),
    answerIsCorrect(){
      return this.question.answer?.toUpperCase() == this.question.user_answer?.toUpperCase()
    }
  },
}
</script>

<style scoped lang="scss">
.success_item {
    background-color: #6bab5c;
}
.marker-number{
  min-height: 22px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.marker-answer{
  min-height: 18px;
  background: #f5f5f5;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
